// extracted by mini-css-extract-plugin
module.exports = {"breakpointTablet":"768px","banner":"BannerCard_banner__yt1xV","card":"BannerCard_card__ygRd_","text":"BannerCard_text__sHqQE"};